const INFO = {
	main: {
		title: "Matthew Cramer - Full-stack Web Developer",
		name: "Matthew C.",
		email: "matthewcramer1382@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://twitter.com/matthewcramer",
		linkedin: "https://www.linkedin.com/in/matthewcramer",
		instagram: "https://instagram.com/_matthewcramer",
		facebook: "https://facebook.com/therealmatthewcramer",
	},

	homepage: {
		title: "Full-stack web and multimedia developer.",
		description:
			"I specialize in multimedia design, development, and online advertising, with proven experience across both agency and corporate environments. My background spans a wide range of creative and technical disciplines, and I excel at guiding projects from concept to completion—consistently meeting deadlines while maintaining the highest quality standards.",
	},

	about: {
		title: "I’m Matthew Cramer. I live in Erie, PA where I create multimedia experiences.",
		description:
			"I specialize in multimedia design, development, and online advertising, with proven experience across both agency and corporate environments. My background spans a wide range of creative and technical disciplines, and I excel at guiding projects from concept to completion—consistently meeting deadlines while maintaining the highest quality standards. As both a collaborative team player and a confident leader, I thrive in environments where I can mentor others, coordinate workflows, and ensure projects move forward smoothly. I can manage resources effectively, provide constructive feedback, and inspire teams to deliver innovative and impactful work. I draw inspiration from multiple creative mediums—including web design, animation, and video production—and I am passionate about leveraging cutting-edge technology to achieve strategic goals.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Train with Reggie",
			description:
				"Website design and developement for Speec & Quickness coach in Eri, PA",
			logo: "../react.png",
			linkText: "View Project",
			link: "https://www.trainwithreggie.com",
		},

		{
			title: "Signal-Tech",
			description:
				"Website design and devlopment. Focus on eCommerce and responsive design",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/php/php.png",
			linkText: "View Project",
			link: "https://www.signal-tech.com",
		},

		{
			title: "Video Reel",
			description:
				"A short reel of video production & 3d/2d animation.",
			logo: "../after-effects.png",
			linkText: "Watch Reel",
			link: "https://youtu.be/-dvwVOUMBm0?si=A4Fdj8bKN2VJamgq",
		},

		{
			title: "Directional Systems Email Campaign",
			description:
				"Email ad tailored to parking customers. HTML/CSS for the build and MailChimp for deployment.",
			logo: "../mailchimp.svg",
			linkText: "View Email Ad",
			link: "https://mailchi.mp/bbe67d0de0b6/clearance-bars-a-simple-solution-to-parking-headaches",
		},

		{
			title: "Signal Tech Recruitment Video",
			description:
				"Created a video to show the culture of Signal-Tech to portential new hires.",
			logo: "../after-effects.png",
			linkText: "Watch Video",
			link: "https://youtu.be/x2IGXnFWJqE?si=DxNjLx20ysYSwDqi",
		},
	],
};

export default INFO;
